import { render } from "./DateFormatted.vue?vue&type=template&id=563a9b3d&ts=true"
import script from "./DateFormatted.vue?vue&type=script&lang=ts"
export * from "./DateFormatted.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__